module.exports = __webpack_public_path__ + "img/qrcode_official.c73c7eb9.png";